import Service from "../Service";
import AuthService from "../AuthService";
import Auth from "./Auth";

const Test = {
  exportSetTest() {
    return AuthService.get("export-set-test");
  },
  exportTest() {
    return AuthService.get("export-test");
  },
  getAllSpecimenTypes() {
    return AuthService.get(`specimen-types`);
  },
  getAllTestTypes() {
    return AuthService.get(`test-types`);
  },
  getAllSetTests() {
    return AuthService.get(`set-tests`);
  },
  getSpecimenType(id) {
    return AuthService.get(`specimen-type?id=${id}`);
  },
  getSettingTestType() {
    return AuthService.get(`settings/test-types`);
  },
  createSettingTestType(payload, token) {
    return AuthService.post(`settings/test-types?token=${token}`, payload);
  },
  updateSettingTestType(payload, id, token) {
    return AuthService.put(`settings/test-types/${id}?token=${token}`, payload);
  },
  deleteSettingTestType(id, token) {
    return AuthService.delete(`settings/test-types/${id}?token=${token}`);
  },
  getSettingTest() {
    return AuthService.get(`settings/tests`);
  },
  createSettingTest(payload, token) {
    return AuthService.post(`settings/tests?token=${token}`, payload);
  },
  updateSettingTest(payload, id, token) {
    return AuthService.put(`settings/tests/${id}?token=${token}`, payload);
  },
  deleteSettingTest(id, token) {
    return AuthService.delete(`settings/tests/${id}?token=${token}`);
  },
  getSettingSubTest() {
    return AuthService.get(`settings/sub-tests`);
  },
  getSettingSubTestByTestId(id) {
    return AuthService.get(`settings/tests/test/${id}/sub-tests`);
  },
  getSettingSubTestBySubTestId(id) {
    return AuthService.get(`settings/tests/subTest/${id}/sub-tests`);
  },
  createSettingSubTest(payload, token) {
    return AuthService.post(`settings/sub-tests?token=${token}`, payload);
  },
  updateSettingSubTest(payload, id, token) {
    return AuthService.put(`settings/sub-tests/${id}?token=${token}`, payload);
  },
  deleteSettingSubTest(id, token) {
    return AuthService.delete(`settings/sub-tests/${id}?token=${token}`);
  },
  getMachine() {
    return AuthService.get(`machine`);
  },
  updateSequenceTestType(payload, token) {
    return AuthService.put(
      `settings/change-sequence-test-types?token=${token}`,
      payload
    );
  },
  updateSequenceTest(payload, token) {
    return AuthService.put(
      `settings/change-sequence-test?token=${token}`,
      payload
    );
  },
  updateSequenceSubTest(payload, token) {
    return AuthService.put(
      `settings/change-sequence-sub-test?token=${token}`,
      payload
    );
  },
  getTestByTestTypeId(id) {
    return AuthService.get(`settings/tests?test_type_id=${id}`);
  },
  getUnits() {
    return AuthService.get(`settings/units`);
  },
  updateUnit(id, payload, token) {
    return AuthService.put(`settings/units/${id}?token=${token}`, payload);
  },
  createUnit(payload, token) {
    return AuthService.post(`settings/units?token=${token}`, payload);
  },
  deleteUnit(id, token) {
    return AuthService.delete(`settings/units/${id}?token=${token}`);
  },
  getTestsBySpecie(specieId) {
    return AuthService.get(`tests?specieId=${specieId}`);
  },
  getSetTestsBySpecie(specieId) {
    return AuthService.get(`set-tests?specieId=${specieId}`);
  },
  getTestRefRangeList(id) {
    return AuthService.get(`tests/ref-range/${id}`);
  },
  getSubTestRefRangeList(id) {
    return AuthService.get(`sub-tests/ref-range/${id}`);
  },
  updateRefRangeList(payload, token) {
    return AuthService.put(`ref-ranges/update-all?token=${token}`, payload);
  },
  deleteCustomRefRange(id, token) {
    return AuthService.delete(`ref-range/delete/${id}?token=${token}`);
  },
  getSetTestById(id) {
    return AuthService.get(`set-tests/${id}`);
  },
  updateSetTest(payload, token) {
    return AuthService.put(`set-tests/update?token=${token}`, payload);
  },
  deleteSetTest(id, token) {
    return AuthService.delete(`set-tests/${id}?token=${token}`);
  },
  getPriceGroupByTestId(id) {
    return AuthService.get(`settings/test-prices/${id}`);
  },
  getPriceGroupBySetTestId(id) {
    return AuthService.get(`settings/set-test-prices/${id}`);
  },
  updateSetTestPriceGroup(payload, token) {
    return AuthService.put(`settings/set-test-prices?token=${token}`, payload);
  },
  updateTestPriceGroup(payload, token) {
    return AuthService.put(`settings/test-prices?token=${token}`, payload);
  },
};

export default Test;
